export{Body,Feature,Fonts,Micro,Super,Title,Typography}from"@vds-core/typography";
